import { Component, Input } from '@angular/core';
import { FieldComponent } from 'tuain-ng-forms-lib';

@Component({
  selector: 'app-warning',
  templateUrl: './app-warning.component.html',
})

export class AppWarningComponent extends FieldComponent {
  @Input() labelType: any;
}
